import { MapPin, Clock, Sparkles, Navigation } from 'lucide-react';
import { motion } from 'framer-motion';

const fadeInUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const MapLocation = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-clay-50 text-clay-600 rounded-full text-sm font-semibold mb-4">
              <Sparkles className="w-4 h-4" />
              Visit Our Office
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-cocoa-900">Find Us in Kolkata</h2>
            <p className="text-cocoa-600 max-w-2xl mx-auto text-lg">
              Located in the heart of the city's craft district
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-2 gap-10 items-stretch">
            {/* Map Container */}
            <motion.div
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5 }}
              className="relative rounded-3xl overflow-hidden shadow-warm border border-cream-200 min-h-[360px] lg:min-h-0"
            >
              <iframe
                title="তন্তিকা Headquarters - Kolkata"
                src="https://www.google.com/maps?q=Kolkata,Bengal,India&z=12&output=embed"
                className="absolute inset-0 w-full h-full border-0"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </motion.div>

            {/* Location Details */}
            <motion.div
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5 }}
              className="bg-gradient-to-br from-clay-50 to-saffron-50 rounded-3xl p-8 md:p-10 border border-cream-200 flex flex-col"
            >
              <h3 className="text-2xl font-bold text-cocoa-900 mb-6">Location Details</h3>

              {/* Address */}
              <div className="mb-8">
                <div className="flex items-start">
                  <div className="w-11 h-11 bg-white rounded-xl flex items-center justify-center shrink-0 mr-4 shadow-sm">
                    <MapPin className="w-5 h-5 text-clay-600" />
                  </div>
                  <div>
                    <h4 className="font-bold text-cocoa-900 mb-2">Address</h4>
                    <p className="text-cocoa-600">
                      Kolkata
                      <br />
                      Bengal, India
                    </p>
                    <a
                      href="https://maps.google.com/?q=Kolkata,Bengal,India"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center mt-4 text-clay-600 font-semibold hover:text-clay-700 group"
                    >
                      <Navigation className="w-4 h-4 mr-2 group-hover:translate-x-0.5 transition-transform" />
                      Open in Google Maps
                    </a>
                  </div>
                </div>
              </div>

              {/* Visiting Hours */}
              <div>
                <div className="flex items-center mb-4">
                  <div className="w-11 h-11 bg-white rounded-xl flex items-center justify-center mr-4 shadow-sm">
                    <Clock className="w-5 h-5 text-saffron-600" />
                  </div>
                  <h4 className="font-bold text-cocoa-900">Visiting Hours</h4>
                </div>
                <div className="bg-white rounded-2xl p-5 shadow-sm border border-cream-200">
                  <div className="space-y-2.5">
                    <div className="flex justify-between">
                      <span className="text-cocoa-600">Monday - Friday</span>
                      <span className="font-semibold text-cocoa-900">9:00 AM - 6:00 PM</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-cocoa-600">Saturday</span>
                      <span className="font-semibold text-cocoa-900">10:00 AM - 4:00 PM</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-cocoa-600">Sunday</span>
                      <span className="font-semibold text-red-500">Closed</span>
                    </div>
                  </div>
                  <div className="mt-4 pt-4 border-t border-cream-100">
                    <p className="text-sm text-cocoa-500">
                      <strong className="text-cocoa-700">Note:</strong> Please schedule an appointment before visiting to ensure someone is available to assist you.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapLocation;
